import BaseApiService from '../baseApi.service';

export default class TargetedTicketDistributionLogService extends BaseApiService {
  readonly basePath: string = 'targetedTicketDistributionLog/v1';
  constructor(props = null) {
    super(props);
  }
}
